import { format, formatRelative } from 'date-fns'
import * as Locales from 'date-fns/locale'

import i18n, { getCurrentLanguage } from '@/i18n'

const locales: { [key: string]: Locale } = { en: Locales.enUS, de: Locales.de }

// TODO move to sdk
export const dateTranslation = function (
  date: number | Date,
  formatStr = 'PP',
) {
  return format(date, formatStr, {
    locale: locales[getCurrentLanguage()],
  })
}

export const dateRelativeTranslation = function (
  date: number | Date,
  formatStr = 'PP',
) {
  const formatRelativeLocale: Record<string, string> = {
    today: `'${i18n.t('today')}'`,
    tomorrow: `'${i18n.t('tomorrow')}'`,
    other: formatStr,
  }

  /**
   * Will return en, de, ru, by, ua, es, whatever user has
   */
  const language = getCurrentLanguage()

  let locale = locales[language]

  if (!locale) {
    locale = locales.en
  }

  if (locale) {
    locale.formatRelative = (key: string) => {
      const res = formatRelativeLocale[key] || formatRelativeLocale.other
      return res
    }
  } else {
    console.warn(`dateTranslation: locale not found`)
  }

  return formatRelative(date, new Date(), { locale })
}
